import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export type CoffeeLock = 'focusedViewLocked' | 'pinsLocked';

export function useUpdateCoffeeLockMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IUser) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ userId, lock, locked }: { userId: string; lock: CoffeeLock; locked: boolean }) => {
			return userSession.webServiceHelper.callAsync<Api.IUser>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: { locked },
					urlPath: `user/${userId}/preferences/coffee/${lock}`,
				}),
				'PUT'
			);
		},
		onError,
		onSuccess,
	});
}
